const baseURL={
	user: process.env.VUE_APP_UMC_BASE_API,
    rac: process.env.VUE_APP_RAC_BASE_API,
	portal: process.env.VUE_APP_PORTAL_BASE_API,
    person: process.env.VUE_APP_PERSON_BASE_API,
	platform: "/uoc/platform-declare-api",//process.env.VUE_APP_PLATFORM_BASE_API,
	//用户管理基础路径
	userBase: "/uoc/umc",
	//文件上传
	file:"/uoc/platform-declare-api",
	fileWithoutAuth:"/platform-declare-api",
	platformNotAuth:"/platform-declare-api",
}
baseURL.formheader = {
	'Accept': 'application/json',
	'Content-Type': 'application/x-www-form-urlencoded'
}
baseURL.jsonheader = {
	'Accept': 'application/json',
	'Content-Type': 'application/json; charset=utf-8'
}
export default baseURL;
